import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles/fonts.css";
import "./styles/animations.css";
import "./styles/components.css";
import "./index.css";
import App from "./App.jsx";
import { initPerformanceOptimizations } from "./utils/performance";

// Initialize performance optimizations
initPerformanceOptimizations({
  optimizeLayouts: true,
  optimizeFonts: true,
});

// Performance optimization - enable lazy loading for all images
if ("loading" in HTMLImageElement.prototype) {
  // Browser supports native lazy loading
  console.log("Native lazy loading supported");
} else {
  // Fallback for browsers that don't support lazy loading
  import("lazysizes").then((lazySizes) => {
    console.log("Using lazysizes as fallback");
  });
}

// Implement intersection observer for better performance
const registerIntersectionObserver = () => {
  if ("IntersectionObserver" in window) {
    // Create and observe all images
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const lazyImage = entry.target;
          if (lazyImage.dataset.src) {
            lazyImage.src = lazyImage.dataset.src;
            lazyImage.removeAttribute("data-src");
          }
          observer.unobserve(lazyImage);
        }
      });
    });

    // Find and observe all images with data-src attribute
    document.addEventListener("DOMContentLoaded", () => {
      const lazyImages = document.querySelectorAll("img[data-src]");
      lazyImages.forEach((img) => {
        observer.observe(img);
      });
    });
  }
};

registerIntersectionObserver();

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <App />
  </StrictMode>
);
